/**
 * 首次落地：把搜索引擎 / AI 来源、搜索词、入口 URL 写入 localStorage。
 * 登录、下单请求由 httpHelper / appendDistributionHeaders 放到 header。
 */
import { captureLandingSource } from '~/utils/landingSource'

export default defineNuxtPlugin(() => {
  captureLandingSource()
})
